import clsx from 'clsx'
import { FC } from 'react'
import TitleAndDesc from '@/components/standard/title-and-desc'
import { useMobileDetector } from '@/hooks/use-mobile-detector'
import PdMedia from '@/components/pd-media/pd-media'
import TagItem from '@/components/standard/tag-item'

type Section6Type = {
  title: string
  mediaUrl: string
  tagGroup: Array<{
    title: string
    desc: string
    mediaUrl: string
  }>
  theme?: string
}

const Section6: FC<Section6Type> = ({ theme, title, mediaUrl = '', tagGroup }) => {
  const isMobile = useMobileDetector()

  return (
    <div className={clsx('w-full h-fit', 'py-15 laptop:py-30', `pd-theme-${theme}`, 'bg-anti-blk')}>
      <TitleAndDesc title={title} desc="" titleTag="h2" />
      <div className={clsx('w-full max-w-300 mx-auto', 'px-6 laptop:px-0')}>
        <div className={clsx('w-full')} style={{ aspectRatio: '2/1' }}>
          <PdMedia src={mediaUrl} mask={false} />
        </div>
        {!!tagGroup?.length && (
          <div className={clsx('gap-8 laptop:gap-6 mt-6', 'flex flex-col laptop:flex-row')}>
            {tagGroup.map((tag, index) => (
              <TagItem
                key={index}
                {...tag}
                contentAlign="left"
                titleClassName="pd-second-title"
                descClassName="pd-third-title"
              />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
export default Section6
